import { DigitalProduct } from "../../../../Redux/digital-product/types";

const DetailPagePolicies = ({ product }: { product: DigitalProduct }) => {
  if (!product) return null;
  return (
    <>
      <div>
        {/* Placeholder for Return Policy if data becomes available */}
        <div
          className={` d-flex justify-content-start align-items-sm-start gap-3 px-1 mb-3`}
        >
          <div className="policy-icons">
            <i className="fi fi-ts-restock fs-0 text-primary"></i>
          </div>
          <div className=" lh-sm">
            <div>
              <b className=" text-black fw-normal">Return & Exchange</b>
            </div>
            <b className=" fw-normal text-xs text-black-50">
              Check product description for return policy.
            </b>
          </div>
        </div>
      </div>
      <div>
        <div
          className={` d-flex justify-content-start align-items-sm-start gap-3 px-1 mb-3`}
        >
          <div className="policy-icons">
            <i className="fi fi-ts-hand-bill fs-0 text-primary"></i>
          </div>
          <div className=" lh-sm">
            <div>
              <b className=" text-black fw-normal">Pay online</b>
            </div>
            <b className=" fw-normal text-xs text-black-50">
              Pay online includes Pay all methods like Paytm, Gpay, PhonePe,
              etc.
            </b>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailPagePolicies;
